import React from 'react';
import { CheckIcon, BookOpenIcon } from '../lib/icons';
import { useReveal } from '../lib/useReveal';
const TOMOS = ['Introducción al Reiki', 'Autosanación y práctica personal', 'Chakras y energía vital', 'Símbolos del Reiki', 'Reiki emocional y espiritual', 'Integración y camino del practicante'];
export function IncludedSection() {
  const [ref1, vis1] = useReveal();
  const [ref2, vis2] = useReveal();
  const [ref3, vis3] = useReveal();
  return <section className="bg-[#faf5ef] py-24 md:py-32 px-4 relative" data-id="element-131">
      <div className="container mx-auto max-w-4xl text-center" data-id="element-132">
        <div ref={ref1} className={`reveal mb-16 ${vis1 ? 'is-visible' : ''}`} data-id="element-133">
          <div className="flex justify-center mb-6" data-id="element-134">
            <div className="bg-green-50 p-3 rounded-full" data-id="element-135">
              <BookOpenIcon className="w-8 h-8 text-green-600" data-id="element-136" />
            </div>
          </div>
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-gray-900 mb-6 leading-tight" data-id="element-137">
            📘 ¿Qué incluye el MegaPack?
          </h2>
          <p className="text-xl font-medium text-gray-600 max-w-2xl mx-auto" data-id="element-138">
            Una biblioteca completa de conocimiento sagrado, <br data-id="element-139" />
            <span className="text-green-700 font-bold" data-id="element-140">
              ✔ 6 Tomos completos de Reiki
            </span>{' '}
            organizados para tu aprendizaje.
          </p>
        </div>

        <div ref={ref2} className={`reveal grid grid-cols-1 md:grid-cols-2 gap-6 mb-16 ${vis2 ? 'is-visible' : ''}`} data-id="element-141">
          {TOMOS.map((tomo, idx) => <div key={idx} className="group flex items-center gap-4 bg-white rounded-xl p-5 border border-gray-100 shadow-sm hover:shadow-md hover:border-green-200 hover:bg-green-50/50 transition-all duration-300" data-id="element-142">
              <div className="flex-shrink-0 w-10 h-10 bg-green-50 rounded-lg flex items-center justify-center group-hover:bg-green-100 transition-colors" data-id="element-143">
                <span className="font-serif font-bold text-green-700" data-id="element-144">
                  {idx + 1}
                </span>
              </div>
              <div className="flex-grow text-left" data-id="element-145">
                <span className="text-xs font-bold text-green-600 uppercase tracking-wider mb-0.5 block" data-id="element-146">
                  Tomo {idx + 1}
                </span>
                <span className="text-gray-800 font-medium text-lg leading-tight block" data-id="element-147">
                  {tomo}
                </span>
              </div>
              <div className="opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-148">
                <CheckIcon className="w-5 h-5 text-green-500" data-id="element-149" />
              </div>
            </div>)}
        </div>

        <div ref={ref3} className={`reveal inline-block bg-gray-50 px-8 py-4 rounded-full border border-gray-200 ${vis3 ? 'is-visible' : ''}`} data-id="element-150">
          <p className="text-lg text-gray-600 italic font-serif" data-id="element-151">
            "Todo explicado de forma clara, simple y aplicable."
          </p>
        </div>
      </div>
    </section>;
}